// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : COMMENT LINES ADDED
// MODFIED DATA : 07-08-2025

const questionnaireTypes = {
	/** ***************** GET QUESTIONNAIRE DETAILS START *********************** */
	GET_QUESTIONNAIRE_START: 'getQuestionnaireStart',
	GET_QUESTIONNAIRE_SUCCESS: 'getQuestionnaireSuccess',
	GET_QUESTIONNAIRE_FAILURE: 'getQuestionnaireFailure',
	GET_QUESTIONNAIRE_RESPONSE_RESET: 'getQuestionnaireResponseReset',
	GET_QUESTIONNAIRE_RESPONSE_CHANGED: 'getQuestionnaireResponseChanged',
	/** ***************** GET QUESTIONNAIRE DETAILS END *********************** */

	/** ***************** DELETE QUESTIONNAIRE DETAILS START *********************** */
	DELETE_QUESTIONNAIRE_START: 'deleteQuestionnaireStart',
	DELETE_QUESTIONNAIRE_SUCCESS: 'deleteQuestionnaireSuccess',
	DELETE_QUESTIONNAIRE_FAILURE: 'deleteQuestionnaireFailure',
	DELETE_QUESTIONNAIRE_RESPONSE_RESET: 'deleteQuestionnaireResponseReset',
	DELETE_QUESTIONNAIRE_RESPONSE_CHANGED: 'deleteQuestionnaireResponseChanged',
	/** ***************** DELETE QUESTIONNAIRE DETAILS END *********************** */

	/** ***************** DELETE QUESTION DETAILS START *********************** */
	DELETE_QUESTION_START: 'deleteQuestionStart',
	DELETE_QUESTION_SUCCESS: 'deleteQuestionSuccess',
	DELETE_QUESTION_FAILURE: 'deleteQuestionFailure',
	DELETE_QUESTION_RESPONSE_RESET: 'deleteQuestionResponseReset',
	DELETE_QUESTION_RESPONSE_CHANGED: 'deleteQuestionResponseChanged',
	/** ***************** DELETE QUESTION DETAILS END *********************** */

	/** ***************** FETCH MODULE LIST START *********************** */
	FETCH_MODULE_LIST_START: 'FETCH_MODULE_LIST_START',
	FETCH_MODULE_LIST_SUCCESS: 'FETCH_MODULE_LIST_SUCCESS',
	FETCH_MODULE_LIST_FAILURE: 'FETCH_MODULE_LIST_FAILURE',
	FETCH_MODULE_LIST_RESET: 'FETCH_MODULE_LIST_RESET',
	FETCH_MODULE_LIST_CHANGED: 'FETCH_MODULE_LIST_CHANGED',
	/** ***************** FETCH MODULE LIST END *********************** */

	/** ***************** ADD QUESTIONNAIRE DETAILS START *********************** */
	ADD_QUESTIONNAIRE_START: 'addQuestionnaireStart',
	ADD_QUESTIONNAIRE_SUCCESS: 'addQuestionnaireSuccess',
	ADD_QUESTIONNAIRE_FAILURE: 'addQuestionnaireFailure',
	ADD_QUESTIONNAIRE_RESPONSE_RESET: 'addQuestionnaireResponseReset',
	ADD_QUESTIONNAIRE_RESPONSE_CHANGED: 'addQuestionnaireResponseChanged',
	/** ***************** ADD QUESTIONNAIRE DETAILS END *********************** */

	/** ***************** FETCH QUESTIONNAIRE DETAILS START *********************** */
	FETCH_QUESTIONNAIRE_START: 'fetchQuestionnaireStart',
	FETCH_QUESTIONNAIRE_SUCCESS: 'fetchQuestionnaireSuccess',
	FETCH_QUESTIONNAIRE_FAILURE: 'fetchQuestionnaireFailure',
	FETCH_QUESTIONNAIRE_RESPONSE_RESET: 'fetchQuestionnaireResponseReset',
	FETCH_QUESTIONNAIRE_RESPONSE_CHANGED: 'fetchQuestionnaireResponseChanged',
	/** ***************** FETCH QUESTIONNAIRE DETAILS END *********************** */

	/** ***************** UPDATE QUESTIONNAIRE DETAILS START *********************** */
	UPDATE_QUESTIONNAIRE_START: 'updateQuestionnaireStart',
	UPDATE_QUESTIONNAIRE_SUCCESS: 'updateQuestionnaireSuccess',
	UPDATE_QUESTIONNAIRE_FAILURE: 'updateQuestionnaireFailure',
	UPDATE_QUESTIONNAIRE_RESPONSE_RESET: 'updateQuestionnaireResponseReset',
	UPDATE_QUESTIONNAIRE_RESPONSE_CHANGED: 'updateQuestionnaireResponseChanged',
	/** ***************** UPDATE QUESTIONNAIRE DETAILS END *********************** */
};
export default questionnaireTypes;
